/* eslint-disable */
import axios from "axios";
axios.defaults.timeout = 6000000; //超时时间设置
axios.defaults.withCredentials = true; //true允许跨域

//Content-Type 响应头
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

if (process.env.NODE_ENV === "production") {
  /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
  if (process.env.VUE_APP_FLAG === "pro") {
    //production 生产环境
    axios.defaults.baseURL = "https://yj.jsxinlicheng.com.cn/api";
  } else {
    //test 测试环境
    axios.defaults.baseURL = "https://yj.jsxinlicheng.com.cn/api";
  }
} else {
  //dev 开发环境
  axios.defaults.baseURL = "http://localhost:8082";
}

// 供直接链接下载使用（与 baseURL 一致）
export function getBaseURL() {
  return axios.defaults.baseURL || (process.env.NODE_ENV === "production" ? "https://yj.jsxinlicheng.com.cn/api" : "http://localhost:8082");
}

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      //closeDebug console.log("response.status !== 200");
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  (error) => {
    //closeDebug console.log("请求error：",error)
    if (error.response) {
      const status = error.response.status;
      if (status) {
        switch (status) {
          // 401: 未登录
          case 401:
            router.replace({
              path: "/",
              query: {
                redirect: router.currentRoute.fullPath,
              },
            });
            break;
          case 403:
            // //closeDebug console.log('管理员权限已修改请重新登录')
            // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
            setTimeout(() => {
              router.replace({
                path: "/",
                query: {
                  redirect: router.currentRoute.fullPath,
                },
              });
            }, 1000);
            break;

          // 404请求不存在
          case 404:
            // //closeDebug console.log('请求页面飞到火星去了')
            break;
          // 404请求不存在
          case 500:
            //closeDebug console.log("服务器处理出错");
            break;
        }
      }
      return Promise.reject(error.response);
    }
    //closeDebug console.log("response error");
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装getImg方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function getImg(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        responseType: "blob", //接收的值类型
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装getFile方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function getFile(url, params = {}) {
  return new Promise((resolve, reject) => {
    let query = params;
    // URLSearchParams / 普通对象统一成 axios 可识别的 plain object
    if (params instanceof URLSearchParams) {
      query = {};
      params.forEach((value, key) => {
        query[key] = value;
      });
    }
    axios
      .get(url, {
        params: query,
        responseType: "blob",
        timeout: 300000,
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    // axios 会自动识别 URLSearchParams 并设置正确的 Content-Type
    // 如果传入的是普通对象，axios 会将其序列化为 JSON
    // 但我们的默认 Content-Type 是 application/x-www-form-urlencoded
    // 所以对于普通对象，需要转换为 URLSearchParams
    let requestData = data;
    
    // 如果已经是 FormData，直接使用
    if (data instanceof FormData) {
      requestData = data;
    } else if (data instanceof URLSearchParams || (typeof data === 'object' && data !== null)) {
      // 统一转为 URLSearchParams，并序列化为字符串，确保后端 getPara() 能收到
      const params = data instanceof URLSearchParams ? data : new URLSearchParams();
      if (!(data instanceof URLSearchParams)) {
        for (const key in data) {
          if (data.hasOwnProperty(key) && data[key] !== undefined && data[key] !== null) {
            if (Array.isArray(data[key])) {
              data[key].forEach((value) => params.append(key + '[]', value));
            } else {
              params.append(key, String(data[key]));
            }
          }
        }
      }
      requestData = params.toString();
    }
    
    const config = typeof requestData === 'string' && requestData.indexOf('=') >= 0
      ? { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } }
      : {};
    axios.post(url, requestData, config).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装带文件上传的post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function postFile(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(
        (response) => {
          resolve(response.data);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function deletes(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}



